import { Turbo } from "@hotwired/turbo-rails"

Turbo.config.forms.confirm = (message) => {
  const content = `
    <dialog id="turbo-confirm" class="p-0 bg-transparent backdrop:bg-black/20 rounded-lg" role="dialog" aria-modal="true">
      <div class="w-[calc(100vw-4rem)] sm:w-[24rem] p-6 bg-white rounded-lg">
        <div class="relative">
          <button value="cancel" form="turbo-confirm-form" class="absolute -top-2 -right-2 p-1 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div class="flex flex-col items-center text-center">
            <div class="flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6 text-indigo-600">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
            </div>
            <h2 class="text-lg font-semibold text-gray-900 mb-2">Are you sure?</h2>
            <p class="text-sm text-gray-500 mb-6 whitespace-pre-line">${message}</p>
          </div>
        </div>
        <form id="turbo-confirm-form" method="dialog" class="flex gap-3">
          <button value="cancel" class="flex-1 inline-flex items-center justify-center gap-2 font-medium rounded-md shadow-sm transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer whitespace-nowrap px-4 py-2 text-sm bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 focus:ring-indigo-500">Cancel</button>
          <button value="confirm" class="flex-1 inline-flex items-center justify-center gap-2 font-medium rounded-md shadow-sm transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer whitespace-nowrap px-4 py-2 text-sm bg-indigo-600 text-white border border-transparent hover:bg-indigo-700 focus:ring-indigo-500">Confirm</button>
        </form>
      </div>
    </dialog>
  `;

  document.body.insertAdjacentHTML("beforeend", content)
  const dialog = document.querySelector("#turbo-confirm")
  dialog.showModal()

  return new Promise((resolve) => {
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue === "confirm")
      dialog.remove()
    })
  })
}
